angular.module('biz-ng-career-details').directive('careerDetails', function jobDetails() {
  'use strict';

  return {
    templateUrl: 'biz-ng-career-details/src/component/career_details.html',
    scope: {
      career: '=',
      settings: '<'
    },
    controller: function ($scope, surveyUIConfiguration) {
      $scope.career._expand = false;
      $scope.showHiringDemand = _.isEmpty($scope.settings) ? true : $scope.settings.showHiringDemand;
      $scope.showSalary = _.isEmpty($scope.settings) ? true : $scope.settings.showSalary;
      $scope.models = {
        careerDataAttributionMessage: surveyUIConfiguration.read().careerDataAttributionMessage
      };
      $scope.flags = {
        hasSalaryData: !_.isNull($scope.career.salaryMin) && !_.isNull($scope.career.salaryMax) && $scope.showSalary,
        hasHiringData: !_.isEmpty($scope.career.hiring_demand) && $scope.showHiringDemand,
        hasEducationData: !_.isEmpty($scope.career.education),
        hasExperienceData: !_.isEmpty($scope.career.experience),
        hasSkillsData: !_.isEmpty($scope.career.topSkills)
      };
      $scope.expandCareerDetails = function expandCareerDetails() {
        $scope.career._expand = !$scope.career._expand;
      };
    }
  };
});



// WEBPACK FOOTER //
// ./app/vendor/biz-ng-career-details/src/component/career_details.js